// Generated by CoffeeScript 2.7.0
var AttachmentField;

export default AttachmentField = Vue.extend({
  props: {
    attachment: {
      type: Object
    },
    fieldTitle: {
      type: String
    },
    fieldMessage: {
      type: String
    },
    requestUrl: {
      type: String
    },
    dataKey: {
      type: String
    },
    acceptType: {
      type: String,
      deafult: 'file'
    },
    fileExtension: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      file: {}
    };
  },
  template: `<div class="form-field attachment-field  has-helper"">
  <div class="form-field-head">
    <div class="form-field-title">{{ fieldTitle }}</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input" v-if="attachment">
      <div class="formable-edit-view ">
        <div class="attachments-container">
          <div class="attachment-list">
            <div class="attachment-item">
              <div class="attachment-type">
                <div class="content-centered">
                  <file-icon :type='file.extension' size='mini' />
                </div>
              </div>
              <div class="attachment-details vertical-middle">
                <span class="attachment-name text-ellipsis">{{ file.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fieldMessage" class="message">{{ fieldMessage }}</div>
    <input class="form-field-value"
            hidden="true"
            placeholder="请输入"
            name='file'
            type="file"
            :accept="acceptType"
            @change="fileChanged"
            ref="fileRef" />
    <button class="change-file-btn" @click="selectFile">选择文件</button>
  </div>
</div>`,
  created: function() {
    return this._generateFile(this.attachment);
  },
  methods: {
    selectFile: function() {
      return this.$refs.fileRef.click();
    },
    fileChanged: function(event) {
      var file, formData;
      file = event.target.files[0];
      formData = new FormData();
      formData.append(`namespace[${this.dataKey}]`, file);
      return Skylark.Libs.Ajax.patch(this.requestUrl, {
        data: formData,
        contentType: false,
        success: (data) => {
          Skylark.Bridge.newAlertify('文件上传成功', {
            type: 'success'
          });
          return this._generateFile(data[this.dataKey]);
        },
        error: function() {
          return Skylark.Bridge.newAlertify('文件上传失败', {
            type: 'danger'
          });
        }
      });
    },
    _generateFile: function(data) {
      var attachment;
      attachment = _.clone(data);
      attachment.extension = this.fileExtension;
      attachment.name = data.filename || this.attachment.filename;
      return this.file = new Skylark.Libs.Storage.Attachment(attachment);
    }
  }
});
